// -----------------------------------------------------------------------------
//
// This file is the copyrighted property of Tableau Software and is protected
// by registered patents and other applicable U.S. and international laws and
// regulations.
//
// Unlicensed use of the contents of this file is prohibited. Please refer to
// the NOTICES.txt file for further details.
//
// -----------------------------------------------------------------------------
import { Action } from 'redux';

import { ResumeExtractRefresh } from '../../../bootstrap/redux/actions/AppActionTypes';
import { IExtractTaskInfo } from '../../../extractTask/models/IExtractTaskInfo';

export interface ResumeExtractRefreshAction extends Action {
  tasks: IExtractTaskInfo[];
}

export function resumeExtractRefresh(tasks: IExtractTaskInfo[]): ResumeExtractRefreshAction {
  return {
    type: ResumeExtractRefresh,
    tasks
  };
}
